import * as Yup from "@braze/yup-legacy";

import type { I18nT } from "@lib/dashboardI18n";
import sharedConstants from "@lib/shared_constants";

import { isCompetitorEmail, isRestrictedEmail, isPartnerEmail, isValidEmail } from "./isRestrictedEmail";

export const workEmailSchema = (t: I18nT<"free-trial-registration">) =>
  Yup.string()
    .required(t("required-work-email-status-text", "Please enter a valid email address"))
    .max(
      sharedConstants.FREE_TRIAL.EMAIL_LENGTH_LIMIT,
      t("email-length-status-text", "Email must be at most {maxEmailLength, number} characters", {
        maxEmailLength: sharedConstants.FREE_TRIAL.EMAIL_LENGTH_LIMIT,
      })
    )
    .test("isValidEmail", t("required-work-email-status-text", "Please enter a valid email address"), (val) =>
      isValidEmail(val)
    )
    .test(
      "isRestrictedEmail",
      t("work-email-status-text", "Must be a company domain. For example: name@company.com"),
      (val) => !isRestrictedEmail(val)
    )
    .test(
      "isCompetitorEmail",
      t("competitor-email-status-text", "Unfortunately, we can’t offer a free trial to this email domain"),
      (val) => !isCompetitorEmail(val)
    )
    .test(
      "isPartnerEmail",
      t("partner-email-status-text", "Unfortunately, we can’t offer a free trial to this email domain"),
      (val) => !isPartnerEmail(val)
    );
